document.querySelectorAll('.disocunt--code').forEach(function (el) {
  el.addEventListener('click', function () {
    const originalHTML = el.innerHTML; // Save full original HTML
    const strong = el.querySelector('strong');
    if (strong) {
      const text = strong.textContent.trim();

      // Copy to clipboard
      navigator.clipboard.writeText(text).then(() => {
        console.log('Copied:', text);

        // Show temporary message (replace entire div content)
        el.innerHTML = '<span class="copied-text-wrapper">Copied to clipboard!</span>';

        // Restore after 2 seconds
        setTimeout(() => {
          el.innerHTML = originalHTML;
        }, 2000);
      }).catch(err => {
        console.error('Copy failed', err);
      });
    }
  });
});
